import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment/moment'
import { dataDefault } from 'Components/User/WasteDrops/BulkoBag'
import { dataDefault as materialTypeDefault } from 'Components/User/WasteDrops/MaterialType'
import { clone } from 'lodash'
import { apiWasteDropsList, apiWasteDropsView } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/wasteDrops/getData', async datas => {
    const { data } = await apiWasteDropsList(datas)
    return data
})

export const getView = createAsyncThunk('admin/wasteDrops/getView', async id => {
    if (!id) return viewData
    const { data } = await apiWasteDropsView(id)
    data.project_id = data.project_id ?? ''
    data.images = []
    data.image_remove = []
    data.material_type = data.material_type && data.material_type.length !== 0 ? data.material_type : [materialTypeDefault]
    var defaultBulkoBag = []
    data.material_type.map(e => {
        var clones = clone(dataDefault)
        clones.waste_drop_material_type_id = e.id
        clones.bags_count = e.bags_count
        defaultBulkoBag.push(clones)
        return e
    })
    data.bulko_bag = data.bulko_bag && data.bulko_bag.length !== 0 ? data.bulko_bag : defaultBulkoBag
    return data
})

const viewData = {
    collection_point_id: '',
    collector_id: '',
    project_id: '',
    type: '0',
    address: '',
    location: '1',
    notes: '',
    images: [],
    image_remove: [],
    material_type: [materialTypeDefault],
    bulko_bag: [dataDefault],
}

export const wasteDropsSlice = createSlice({
    name: 'admin/wasteDrops',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            start: moment().startOf('month').locale('en').format('YYYY-MM-DD'),
            end: moment().endOf('month').locale('en').format('YYYY-MM-DD'),
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setDate: (state, { payload: { start, end } }) => {
            state.table.start = start
            state.table.end = end
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData, setDate } = wasteDropsSlice.actions

export default wasteDropsSlice.reducer
